import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cc from 'classcat';
import PropTypes from 'prop-types';
import React from 'react';
import LazyImg from '../LazyImg';
import css from './FeatureProductBlock.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var FeatureProductBlock = function FeatureProductBlock(_ref) {
  var author = _ref.author,
      color = _ref.color,
      copy = _ref.copy,
      id = _ref.id,
      image = _ref.image,
      imageRight = _ref.imageRight,
      price = _ref.price,
      title = _ref.title,
      url = _ref.url;
  return /*#__PURE__*/_jsx("div", {
    className: cc([css.root, _defineProperty({}, css.imageRight, imageRight)]),
    children: /*#__PURE__*/_jsxs("a", {
      className: css.link,
      href: url,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.sizer,
        children: /*#__PURE__*/_jsxs("div", {
          className: css.content,
          children: [/*#__PURE__*/_jsx(LazyImg, {
            alt: "feature-".concat(id, "-").concat(title),
            className: css.image,
            src: image
          }), /*#__PURE__*/_jsxs("div", {
            className: css.copy,
            children: [/*#__PURE__*/_jsx("p", {
              className: cc([css.copyInner, _defineProperty({}, css.quote, author)]),
              children: "".concat(author ? '"' : '').concat(copy).concat(author ? '"' : '')
            }), author && /*#__PURE__*/_jsx("p", {
              className: css.author,
              children: "\u2014 ".concat(author)
            })]
          })]
        })
      }), /*#__PURE__*/_jsx("p", {
        className: css.info,
        children: "".concat(title, " in ").concat(color, ", $").concat(price)
      })]
    })
  });
};

FeatureProductBlock.defaultProps = {
  author: false,
  imageRight: false
};
FeatureProductBlock.propTypes = {
  author: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  color: PropTypes.string.isRequired,
  copy: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  imageRight: PropTypes.bool,
  price: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};
export default FeatureProductBlock;